module.exports = __webpack_public_path__ + "static/angle-down-disabled.ea14adb57af4ff2d311abde8a0f6fb36.svg";